import styled from 'styled-components'

const SignatureContainer = styled.div`
	display: flex;
	flex-direction: column;
`

export default SignatureContainer